import { getSubscriberDeclarations } from "@services/subscriber";
import { useQuery } from "@tanstack/react-query";

/** The selected scheme's readings in its active accounting period, or in the one `accountingPeriodId` names. */
export function useSubscriberDeclarations({
  params,
  ...options
}: {
  params?: { accountingPeriodId?: string };
  [key: string]: any;
} = {}) {
  return useQuery<any>({
    queryKey: ["subscriberDeclarations", params],
    queryFn: () => getSubscriberDeclarations(params),
    ...options,
  });
}
